export const ROOM_TAX_RATE = 0.18;
export const ROOM_TAX_DIVISOR = 1 + ROOM_TAX_RATE;

/** Extracts the 18% inclusive tax component from the final room price. */
export function roomTaxesFromDiscounted(discountedPrice) {
  const d = Number(discountedPrice) || 0;
  return Math.round((d * ROOM_TAX_RATE / ROOM_TAX_DIVISOR) * 100) / 100;
}
